/**
 * `ez.t.item_created_or_updated` — the trigger half of static recipe `6001`
 * (*"When an item is created or updated, create an event in Google Calendar, and sync future
 * changes from this board"*).
 *
 * One trigger, three outbox types, because monday's sentence is one trigger: a create, a rename
 * and any cell write all reach it. `sync future changes` in monday's sentence is a two-way sync
 * we deliberately do not implement (`specs/M6-A4` §9) — the automation creates the event and
 * says so in the run log rather than pretending the calendar stays in step.
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
export const itemCreatedOrUpdatedParams = z.object({});
export const itemCreatedOrUpdatedTrigger = defineTrigger({
    id: 'ez.t.item_created_or_updated',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When an item is created or updated',
    paramsSchema: itemCreatedOrUpdatedParams,
    subscribes: ['item.created', 'item.updated', 'cell.changed'],
    assumed: true,
    references: () => [],
    matches: (event) => event.itemId !== null,
    outputs: (event) => ({ itemId: event.itemId, boardId: event.boardId, cause: event.type }),
});
//# sourceMappingURL=ez.t.item-created-or-updated.js.map